import {Sine, TweenLite} from "gsap";
import {TemplateVariables} from "springroll/typings/Renderer";
import {Container} from "../core/Container";
import {Assets} from "../data/Assets";
import {ICaptionRenderer} from "../managers/CaptionManager";

export class DefaultCaptionRenderer extends Container implements ICaptionRenderer {

    private readonly _bg: PIXI.Sprite;
    private readonly _text: PIXI.extras.BitmapText;
    private _textTween?: TweenLite;
    private _bgTween?: TweenLite;
    private readonly _size = new PIXI.Point();

    constructor() {
        super();

        this._bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._bg.anchor.set(0.5, 0);
        this._bg.height = 60;
        this._bg.tint = 0x000000;
        this._bg.alpha = 0;
        this.addChild(this._bg);

        this._text = new PIXI.extras.BitmapText("", {
            font: {
                name: Assets.fontGrandstander.assetName,
                size: 40,
            },
            align: "center",
        });
        this._text.alpha = 0;
        this._text.visible = false;
        this.addChild(this._text);
    }

    public start(): void {
        this._text.visible = true;
        this._bg.visible = true;
        this.killTween(this._textTween);
        this.killTween(this._bgTween);
        this._textTween = new TweenLite(this._text, 0.25, {
            alpha: 1,
            ease: Sine.easeInOut,
        });
        this._bgTween = new TweenLite(this._bg, 0.15, {
            alpha: 0.6,
            ease: Sine.easeInOut,
        });
    }

    public stop(): void {
        this.killTween(this._textTween);
        this.killTween(this._bgTween);
        this._textTween = new TweenLite(this._text, 0.25, {
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: () => {
                this._text.visible = false;
            },
        });
        this._bgTween = new TweenLite(this._bg, 0.25, {
            delay: 0.25,
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: () => {
                this._bg.visible = false;
            },
        });
    }

    public lineBegin(line: { content: string, templateVariables: TemplateVariables }): void {
        let text = line.content
            .replace(/<[^>]*>/ig, "") // remove html tags
            .replace(/\[.*][^\w]*/ig, ""); // remove brackets
        text = text.charAt(0).toUpperCase() + text.slice(1);
        this._text.text = text;
        this.onResize(this._size);
    }

    public lineEnd(): void {
        // no implementation
    }

    public onResize(pSize: PIXI.Point): void {
        this._size.x = pSize.x;
        this._size.y = pSize.y;

        this._bg.width = this._size.x;
        this._bg.position.set(this._size.x * 0.5, 0);

        this._text.maxWidth = this._size.x * 2 - 400;
        this._text.scale.set(0.5);
        this._text.position.set(
            (this._size.x - this._text.width) * 0.5,
            (this._bg.height - this._text.height) * 0.5,
        );
    }

    private killTween(pTween: TweenLite | undefined): void {
        if (pTween !== undefined) {
            pTween.kill();
        }
    }
}
